import React from "react";
import { Skeleton } from "boneyard-js/react";
import styled from "styled-components";

const BONES_COLOR = "var(--rms-v2-border-soft, #e5ebf3)";
const BONES_SHIMMER = "var(--rms-v2-surface-muted, #f4f7fb)";

const ordersBones = {
  name: "v2-orders",
  viewportWidth: 414,
  width: 414,
  height: 760,
  bones: [
    [4.35, 26, 8.7, 20, 4],
    [42.03, 28, 15.94, 14, 4],
    [4.35, 94, 30.43, 26, 6],
    [4.35, 130, 76.81, 18, 4],
    [4.35, 168, 91.3, 54, 10, true],
    [11.11, 186, 57.97, 16, 6],
    [4.35, 250, 91.3, 176, 10, true],
    [8.7, 274, 24.15, 12, 4],
    [67.63, 274, 23.19, 12, 4],
    [76.81, 298, 14.49, 20, 4],
    [8.7, 338, 16.43, 68, 5],
    [25.6, 338, 16.43, 68, 5],
    [42.51, 338, 16.43, 68, 5],
    [8.7, 448, 91.3, 176, 10, true],
    [8.7, 472, 24.15, 12, 4],
    [67.63, 472, 23.19, 12, 4],
    [76.81, 496, 14.49, 20, 4],
    [8.7, 536, 16.43, 68, 5],
    [25.6, 536, 16.43, 68, 5],
    [42.51, 536, 16.43, 68, 5],
    [4.35, 676, 91.3, 56, 10],
  ],
};

const productsBones = {
  name: "v2-products",
  viewportWidth: 414,
  width: 414,
  height: 780,
  bones: [
    [4.35, 26, 8.7, 20, 4],
    [37.2, 26, 25.6, 22, 4],
    [8.7, 100, 58.45, 32, 6],
    [8.7, 146, 80.19, 18, 4],
    [8.7, 172, 70.53, 18, 4],
    [8.7, 224, 82.61, 150, 10, true],
    [12.56, 248, 22.22, 92, 10],
    [39.13, 254, 42.03, 20, 5],
    [39.13, 286, 34.78, 14, 4],
    [39.13, 314, 35.75, 18, 4],
    [12.56, 390, 82.61, 118, 10, true],
    [16.43, 414, 22.22, 70, 10],
    [43.0, 416, 38.65, 20, 5],
    [43.0, 446, 35.75, 14, 4],
    [86.47, 420, 6.04, 25, "50%"],
    [12.56, 524, 82.61, 118, 10, true],
    [16.43, 548, 22.22, 70, 10],
    [43.0, 550, 38.65, 20, 5],
    [43.0, 580, 35.75, 14, 4],
    [86.47, 554, 6.04, 25, "50%"],
    [8.7, 690, 82.61, 68, 10],
  ],
};

const paymentDetailsBones = {
  name: "v2-payment-details",
  viewportWidth: 414,
  width: 386,
  height: 156,
  bones: [
    [0, 0, 100, 156, 10, true],
    [4.15, 16, 34, 18, 4],
    [4.15, 54, 40, 14, 4],
    [76, 54, 20, 14, 4],
    [4.15, 84, 34, 14, 4],
    [82, 84, 14, 14, 4],
    [4.15, 122, 38, 18, 4],
    [72, 122, 24, 18, 4],
  ],
};

const compactCardBones = {
  name: "v2-compact-card",
  viewportWidth: 414,
  width: 386,
  height: 150,
  bones: [
    [0, 0, 100, 150, 10, true],
    [4.15, 18, 45, 18, 4],
    [4.15, 52, 92, 18, 4],
    [4.15, 82, 92, 18, 4],
    [4.15, 112, 68, 18, 4],
  ],
};

const trackingBones = {
  name: "v2-tracking",
  viewportWidth: 414,
  width: 414,
  height: 760,
  bones: [
    [4.35, 26, 8.7, 20, 4],
    [34, 26, 32, 22, 4],
    [8.7, 96, 82.61, 110, 10, true],
    [12.56, 122, 22.22, 62, 8],
    [39.13, 124, 42.03, 18, 4],
    [39.13, 152, 35.75, 14, 4],
    [8.7, 238, 82.61, 220, 10, true],
    [14.5, 266, 70, 16, 4],
    [14.5, 310, 70, 16, 4],
    [14.5, 354, 70, 16, 4],
    [8.7, 492, 82.61, 120, 10, true],
  ],
};

const LoaderShell = styled.div`
  .boneyard-fixture {
    opacity: 0;
    pointer-events: none;
  }

  [data-boneyard-overlay="true"] {
    background: var(--rms-v2-section-bg, #f5f5f5);
  }
`;

const V2FixtureShell = styled.div`
  min-height: 760px;
  background: var(--rms-v2-section-bg, #f5f5f5);
  color: var(--rms-v2-text-title, #252c36);
  max-width: 500px;
  margin: 0 auto;

  .fixture-header {
    height: 60px;
    display: grid;
    grid-template-columns: 48px 1fr 48px;
    align-items: center;
    background: var(--rms-v2-surface, #fff);
    border-bottom: 1px solid var(--rms-v2-border-soft, #e4eaf2);
    padding: 0 14px;
  }

  .fixture-content {
    padding: 10px 18px 120px;
  }

  .fixture-content h1 {
    color: var(--rms-v2-text-title, #252c36);
    font-size: 20px;
    font-weight: 900;
    margin: 10px 0 6px;
  }

  .fixture-content p {
    color: var(--rms-v2-text-muted, #5f6b7a);
    font-size: 14px;
    margin: 0 0 16px;
  }

  .fixture-card {
    background: var(--rms-v2-surface, #fff);
    border: 1px solid var(--rms-v2-border, #dce4ef);
    border-radius: 10px;
    box-shadow: none;
    min-height: 150px;
    margin-top: 14px;
  }
`;

function BoneyardLoader({ name, bones, children }) {
  return (
    <LoaderShell>
      <Skeleton
        name={name}
        loading
        initialBones={bones}
        color={BONES_COLOR}
        shimmerColor={BONES_SHIMMER}
        animate="shimmer"
      >
        <div className="boneyard-fixture">{children}</div>
      </Skeleton>
    </LoaderShell>
  );
}

export function V2OrdersBoneyardLoader() {
  return (
    <BoneyardLoader name="v2-orders" bones={ordersBones}>
      <V2FixtureShell>
        <div className="fixture-header" />
        <div className="fixture-content">
          <h1>Your Orders</h1>
          <p>Select a product to manage returns, exchanges, or track status.</p>
          <div className="fixture-card" />
          <div className="fixture-card" />
        </div>
      </V2FixtureShell>
    </BoneyardLoader>
  );
}

export function V2ProductsBoneyardLoader() {
  return (
    <BoneyardLoader name="v2-products" bones={productsBones}>
      <V2FixtureShell>
        <div className="fixture-header" />
        <div className="fixture-content">
          <h1>Order #ORD-88219</h1>
          <p>Choose the items you wish to return or exchange from your order.</p>
          <div className="fixture-card" />
          <div className="fixture-card" />
          <div className="fixture-card" />
        </div>
      </V2FixtureShell>
    </BoneyardLoader>
  );
}

export function V2PaymentDetailsBoneyardLoader() {
  return (
    <BoneyardLoader name="v2-payment-details" bones={paymentDetailsBones}>
      <div
        style={{
          minHeight: 156,
          background: "var(--rms-v2-surface, #fff)",
          borderRadius: 10,
          border: "1px solid var(--rms-v2-border, #dce4ef)",
        }}
      >
        <h2>Refund Details</h2>
        <p>Subtotal of Products (Refund)</p>
        <p>Shipping Charges</p>
        <strong>Total Amount to be refunded</strong>
      </div>
    </BoneyardLoader>
  );
}

export function V2CompactCardBoneyardLoader() {
  return (
    <BoneyardLoader name="v2-compact-card" bones={compactCardBones}>
      <div
        style={{
          minHeight: 150,
          background: "var(--rms-v2-surface, #fff)",
          borderRadius: 10,
          border: "1px solid var(--rms-v2-border, #dce4ef)",
        }}
      >
        <h2>Loading</h2>
        <p>Preparing latest details</p>
        <p>Please wait</p>
      </div>
    </BoneyardLoader>
  );
}

export function V2TrackingBoneyardLoader() {
  return (
    <BoneyardLoader name="v2-tracking" bones={trackingBones}>
      <V2FixtureShell>
        <div className="fixture-header" />
        <div className="fixture-content">
          <div className="fixture-card" />
          <div className="fixture-card" />
          <div className="fixture-card" />
        </div>
      </V2FixtureShell>
    </BoneyardLoader>
  );
}
